exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Rectangle-4 {\n  background-color: #ffffff;\n  border: solid 1px #dfe4e7;\n  height: auto;\n  padding-right: 1em; }\n\n.layer {\n  width: 100%;\n  height: auto; }\n\ntextarea {\n  width: 100%; }\n\n.textwrapper {\n  border: 1px solid #999999;\n  margin: 5px 0;\n  padding: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/additional-executive-summary/additional-executive-summary.component.scss
// module id = ../../../../../src/app/securities-level/additional-executive-summary/additional-executive-summary.component.scss
// module chunks = main